module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_prp01-d1ec28496fc02530b5b03db82996aa79.svg";